import React, { FC, useEffect, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import { checkBox, newThemeInput } from '_fields/inputs';
import { phone, lowerCase, words } from '_fields/normalizers';
import { connect } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
// import { validateUserByEmail } from '../../../api/validateUserByEmail';
import { formValueSelector } from 'redux-form';
import { useForm } from 'react-hook-form';
import { Form } from '@components/shadcn/components/ui/form';
import { RootState } from '@store/reducers';
import { Spinner } from '@components/Spinner/Spinner';
import { Helmet } from 'react-helmet';
import { Button, cn, Stack, Text, useIsInIframe } from 'shared-components';
import {
  ApplyWizardSteps,
  STEP_INTEGRATED_LOGIN,
  STEP_INFO,
  STEP_EQ_LEAD_YOUR_INFORMATION,
  FIELD_VALIDATION,
} from '@components/ApplyWizard/ApplyWizardSteps';
import { reduxFormZodValidate } from '@utils/reduxFormZodValidate';
import { Auth0LoggedInSetState } from '../../../Auth0LoggedInSetState';
import { useApplyWizardContext } from '../../../context/ApplyWizardContext';
import { change } from 'redux-form';
import { Dispatch } from 'redux';
import withLeadOnSubmit from '@components/Apply/withOnSubmit/withLeadOnSubmit';
import ensureNotLoggedIn from '../../../hooks/ensureNotLoggedIn';
import { z } from 'zod';
import { EQFlowFooter } from '../_shared/EQFlowFooter';

type EnhancedInfoProps = {
  dispatch: Dispatch;
  change: any;
  partnerCustomFields: any;
  vendor_url: string;
  ownerEmail: string;
  loanType: string;
  saving: boolean;
  handleSubmit: () => void;
  invalid: boolean;
  user: RootState['user'];
  owner_1_first?: string;
  owner_1_last?: string;
  owner_1_mobile?: string;
  isNotAnOwner?: boolean;
};

const EnhancedInfo: FC<EnhancedInfoProps> = (props) => {
  const auth0 = useAuth0();

  if (auth0.isLoading) {
    return (
      <div className="app-section slide infoSLide">
        <Spinner />
      </div>
    );
  }

  return <EnhancedInfoInner {...props} />;
};
const EnhancedInfoInner: FC<EnhancedInfoProps> = ({
  dispatch,
  change,
  handleSubmit,
  invalid,
  saving: savingOnSubmit,
  vendor_url,
  ownerEmail,
  user,
  owner_1_first,
  owner_1_last,
  owner_1_mobile,
  isNotAnOwner,
}) => {
  const auth0 = useAuth0();
  const isOpenedInIframe = useIsInIframe();

  const form = useForm();
  // const [{ data: validateUserResponse, loading: validateUserLoading, error: validateUserError }, validateUser] =
  //   validateUserByEmail();
  const { changeStepTo, saving } = useApplyWizardContext();
  const privacyLink = `${vendor_url}/privacy-policy`;
  const termsLink = `${vendor_url}/terms`;
  const [error, setError] = useState(false);

  // useEffect(() => {
  //   if (validateUserResponse) {
  //     if (validateUserResponse.userWithThisEmailExists === false) {
  //       // if (changeStepTo && isOpenedInIframe) {
  //       // changeStepTo(ApplyWizardSteps[STEP_INTEGRATED_LOGIN].id);
  //       // } else {
  //       handleSubmit();
  //       // }
  //     } else if (validateUserResponse.userWithThisEmailExists === true) {
  //       setError(true);
  //     }
  //   }
  // }, [validateUserResponse]);
  useEffect(() => {
    dispatch(change('application', 'application_type', 'eqlead'));
  }, []);

  return (
    <div className="w-full">
      <Helmet>
        <title>Basic Info - Your Loan Application</title>
      </Helmet>
      <div className="w-full flex flex-col gap-[20px] mt-[16px]">
        <Auth0LoggedInSetState />
        <Text variant="subheadline-sm2" className="!text-[16px] !font-extended py-[20px] !leading-[100%]">
          PRE-QUALIFY IN LESS THAN 3 MINUTES
        </Text>
        <Text variant="subheadline-sm2" className="!text-[20px] !font-standard !leading-[30px]">
          Your Information
        </Text>
        <Form {...form}>
          <form
            // Remove ValidateUser onSubmit for now for Lead until decide otherwise
            // onSubmit={(e) => {
            //   e.preventDefault();
            //   setError(false);
            //   validateUser({ data: { email: ownerEmail } });
            // }}
            onSubmit={handleSubmit}
            className="slideWidth w-full"
          >
            <div className="w-full flex flex-col gap-[20px] mb-[40px]">
              <div className="w-full flex flex-col items-center gap-[5px]">
                {/* <Field
                  autoFocus
                  name="business_name"
                  component={newThemeInput}
                  type="text"
                  placeholder="Company Name*"
                  normalize={words}
                  label="Business Name*"
                  data-testid="business_name"
                  className="!max-w-[592px]"
                  variant="transparent-black"
                /> */}

                <Stack
                  flow="column"
                  templateColumns="1fr 1fr"
                  gapVariant="input-to-input"
                  alignItems="start"
                  className={cn('gap-[10px] w-full max-w-[592px]')}
                >
                  <Field
                    name={isNotAnOwner ? 'owner_0_first' : 'owner_1_first'}
                    component={newThemeInput}
                    type="text"
                    label="First Name*"
                    placeholder={isNotAnOwner ? 'Submitter First Name*' : 'First Name*'}
                    normalize={words}
                    data-testid="owner_1_first"
                    className="!max-w-[592px]"
                    variant="transparent-black"
                  />
                  <Field
                    name={isNotAnOwner ? 'owner_0_last' : 'owner_1_last'}
                    component={newThemeInput}
                    type="text"
                    label="Last Name*"
                    placeholder={isNotAnOwner ? 'Submitter Last Name*' : 'Last Name*'}
                    normalize={words}
                    data-testid="owner_1_last"
                    className="!max-w-[592px]"
                    variant="transparent-black"
                  />
                </Stack>

                <Field
                  name={isNotAnOwner ? 'owner_0_email' : 'owner_1_email'}
                  component={newThemeInput}
                  type="email"
                  label={auth0.isAuthenticated && user.email ? 'Email (disabled)' : 'Email*'}
                  placeholder={isNotAnOwner ? 'Submitter Email*' : 'Email*'}
                  normalize={lowerCase}
                  data-testid="owner_1_email"
                  disabled={!!(auth0.isAuthenticated && user.email)}
                  className="!max-w-[592px]"
                  variant="transparent-black"
                />

                <Field
                  name={isNotAnOwner ? 'owner_0_mobile' : 'owner_1_mobile'}
                  component={newThemeInput}
                  label="Mobile Phone*"
                  placeholder={isNotAnOwner ? 'Submitter Mobile Phone*' : 'Mobile Phone*'}
                  formatAsPhone
                  data-testid="owner_1_mobile"
                  className="!max-w-[592px]"
                  variant="transparent-black"
                />
                {/* {auth0.isAuthenticated && user.email && (
                  <div className="input-caption">You are logged in with this email.</div>
                )} */}
                {error && (
                  <div className="text-[#FF0000] font-bold">
                    This email is already registered with us. Please{' '}
                    <span
                      onClick={() => {
                        if (changeStepTo && isOpenedInIframe) {
                          changeStepTo(ApplyWizardSteps[STEP_INTEGRATED_LOGIN].id);
                        } else {
                          auth0.loginWithRedirect({
                            appState: {
                              returnTo: '/app/verify/login',
                            },
                            authorizationParams: {
                              connection: 'email',
                              screen_hint: 'signup',
                              login_hint: ownerEmail,
                              ...(owner_1_first
                                ? {
                                    'user[given_name]': owner_1_first,
                                  }
                                : {}),
                              ...(owner_1_last
                                ? {
                                    'user[family_name]': owner_1_last,
                                  }
                                : {}),
                              ...(owner_1_mobile
                                ? {
                                    'user[phone_number]': owner_1_mobile,
                                  }
                                : {}),
                            },
                          });
                        }
                      }}
                      className="!text-[#0000EE] !underline"
                    >
                      login
                    </span>
                  </div>
                )}
                <div className="consent-box !max-w-[592px] w-full">
                  <Field
                    component={checkBox}
                    id="consent"
                    name="consent"
                    className=" !max-w-[592px]"
                    stackProps={{
                      className: 'w-full !max-w-[592px]',
                    }}
                    variant="transparent-black"
                    data-testid="consent_check"
                    children={
                      <label htmlFor="consent">
                        I agree to the{' '}
                        <a target="_blank" href={termsLink} className="!no-underline !text-moss" tabIndex={-1}>
                          terms and conditions
                        </a>{' '}
                        and{' '}
                        <a target="_blank" href={privacyLink} className="!no-underline !text-moss" tabIndex={-1}>
                          privacy policy
                        </a>
                        .
                      </label>
                    }
                  />
                </div>
              </div>
              <div className="w-full flex flex-col items-center justify-center gap-[20px] mx-auto">
                <Button
                  variant="primary-green"
                  color="primary"
                  type="submit"
                  disabled={invalid || saving}
                  // isLoading={saving || validateUserLoading}
                  isLoading={saving || savingOnSubmit}
                  data-testid="info_continue"
                  className="!max-w-[592px] !h-[50px] border-[1px] border-spark2 !py-[12.5px] font-condensed leading-[120%] px-[50px] !text-[16px]"
                >
                  CONTINUE
                </Button>
                <Text variant="body-form-label" className="!text-[16px] !leading-[18px] !font-condensed text-charcoal2">
                  *NO HARD CREDIT CHECKS
                </Text>
              </div>
            </div>
          </form>

          <EQFlowFooter />
        </Form>
      </div>
    </div>
  );
};

export const reduxFormConditionalZodValidate = () => (values: any, props: EnhancedInfoProps) => {
  const errors = {};
  try {
    if (props.isNotAnOwner) {
      z.object({
        owner_0_first: FIELD_VALIDATION.owner_1_first,
        owner_0_last: FIELD_VALIDATION.owner_1_last,
        owner_0_mobile: FIELD_VALIDATION.owner_1_mobile,
        owner_0_email: FIELD_VALIDATION.owner_1_email,
        consent: z.boolean().refine((value: boolean) => value, 'Consent is required to proceed.'),
      }).parse(values);
    } else {
      z.object({
        owner_1_first: FIELD_VALIDATION.owner_1_first,
        owner_1_last: FIELD_VALIDATION.owner_1_last,
        owner_1_mobile: FIELD_VALIDATION.owner_1_mobile,
        owner_1_email: FIELD_VALIDATION.owner_1_email,
        consent: z.boolean().refine((value: boolean) => value, 'Consent is required to proceed.'),
      }).parse(values);
    }
  } catch (e) {
    if (e instanceof z.ZodError) {
      e.issues.forEach((error) => {
        if (error.path.length > 0) {
          // Assume the path has the field name
          const fieldName = error.path[0];
          (errors as any)[fieldName] = error.message;
        }
      });
    }
  }

  return errors;
};

const Info = reduxForm<EnhancedInfoProps, EnhancedInfoProps>({
  form: 'application',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: reduxFormConditionalZodValidate(),
})(EnhancedInfo);
const appSelector = formValueSelector('application');

const mapStateToProps = (state: RootState) => {
  return {
    partnerCustomFields: state.partnerCustomFields,
    vendor_url: state.brand?.data?.vendor_url,
    ownerEmail: appSelector(state, 'owner_1_email'),
    user: state.user,
    isNotAnOwner: appSelector(state, 'isNotAnOwner'),
    owner_1_first: appSelector(state, 'owner_1_first'),
    owner_1_last: appSelector(state, 'owner_1_last'),
    owner_1_mobile: appSelector(state, 'owner_1_mobile'),
  };
};

export const EQLeadFlowYourInformationStep = ensureNotLoggedIn(
  withLeadOnSubmit(
    connect(mapStateToProps, (dispatch) => ({
      change,
      dispatch,
    }))(Info),
    STEP_EQ_LEAD_YOUR_INFORMATION
  )
);
